import { render, staticRenderFns } from "./BuchVerlagsVerkaeufeDetail.vue?vue&type=template&id=69780295&scoped=true&"
import script from "./BuchVerlagsVerkaeufeDetail.vue?vue&type=script&lang=ts&"
export * from "./BuchVerlagsVerkaeufeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BuchVerlagsVerkaeufeDetail.vue?vue&type=style&index=0&id=69780295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69780295",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
